export enum TestimonialSections {
  AVATAR_SECTION = "avatar",
  USERNAME_SECTION = "name",
  BIO_SECTION = "bio",
  REVIEW_CONTENT_SECTION = "content",
  DATE_SECTION = "date",
  OVERALL_CARD_SECTION = "card",
  RATING_SECTION = "rating",
}

export interface TestimonialCardStyleKit {
  [TestimonialSections.OVERALL_CARD_SECTION]: {
    outlineWidth: string;
    outlineColor: string;
    padding: string;
    borderRadius: string;
    shadow: string;
    mode: "light" | "dark";
    layout: LayoutTypes;
  };

  [TestimonialSections.AVATAR_SECTION]: {
    size: number;
    borderRadius: string;
    visibility: string;
    defaultAvatar: string;
  };

  [TestimonialSections.USERNAME_SECTION]: {
    size: number;
    color: string;
    fontWeight: string;
    fontSize: string;
    fontFamily: string;
  };

  [TestimonialSections.BIO_SECTION]: {
    size: number;
    color: string;
    fontWeight: string;
    fontSize: string;
    fontFamily: string;
  };

  [TestimonialSections.REVIEW_CONTENT_SECTION]: {
    size: number;
    color: string;
    fontWeight: string;
    fontSize: string;
    lineHeight: number;
    fontFamily: string;
    display: string;
    WebkitLineClamp: number;
    WebkitBoxOrient: string;
    overflow: string;
  };

  [TestimonialSections.DATE_SECTION]: {
    size: number;
    color: string;
    fontWeight: string;
    fontSize: string;
    visibility: boolean;
    fontFamily: string;
  };

  [TestimonialSections.RATING_SECTION]: {
    color: string;
    outlineWidth: string;
    outlineColor: string;
    size: string;
  };
}
export enum LayoutTypes {
  STACK = "stack",
  SPLIT = "split",
  COMPACT = "compact",
  CENTERED = "centered",
}
